import { OrderItemViewModel } from 'store/models/sellModels'
import { CartItem, ICartItemProps } from './CartItem'
import CartContext, { ICartContext } from './CartContext'
import { useEffect, useRef } from 'react'
import LoadingDot from 'AppRoot/InstallingScreen/InstallingSplashScreen/LoadingDot'

interface ICartProps extends Omit<ICartItemProps, 'item'> {
    items: OrderItemViewModel[]
    dependencies: ICartContext
    isShownInSplitPayment?: boolean
}

export default function Cart(props: ICartProps) {
    const {
        items,
        dependencies,
        onValidateCartItems,
        isShownInSplitPayment,
    } = props
    const ref = useRef(dependencies.unavailableProducts)

    // if unavailable product changed it will validate cartItems
    useEffect(() => {
        if (!onValidateCartItems) return
        if (ref.current !== dependencies.unavailableProducts) {
            onValidateCartItems(dependencies.unavailableProducts)
        }
    }, [dependencies.unavailableProducts, onValidateCartItems])

    return (
        <CartContext.Provider
            value={{
                ...dependencies,
            }}
        >
            {items.length !== 0 ? (
                items.map((i: OrderItemViewModel) => (
                    <CartItem
                        {...props}
                        key={i.id + '-order-item-cart-list'}
                        item={i}
                    />
                ))
            ) : isShownInSplitPayment ? (
                <LoadingDot />
            ) : (
                <></>
            )}
        </CartContext.Provider>
    )
}
